import capitalize from './capitalize';
export var getAccountSelectionTextFromMaskedAccount = function (maskedAccount) {
    if (maskedAccount) {
        return "".concat(maskedAccount.accountName
            ? maskedAccount.accountName
            : capitalize(maskedAccount.accountType), " (*").concat(maskedAccount.accountNumberLastFour, ")");
    }
    return null;
};
